export default __webpack_public_path__ + "static/media/upload-photo-icon.23dd9490.svg";